import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom';
import {Box, Text,Button,Tag } from 'grommet';
import {FormPrevious,DocumentDownload } from 'grommet-icons';
import { NavigationSnackBar, ReturnRowDir } from '../../components/utils/shared/shared';
import { ReturnLocation,ReturnCollectionDetails,ShipmentSuccessNotification,StatusChip,ReturnTotalWeight } from '../../components/utils/shared/shipmentViewFunctions';
import GetS3Document from '../../components/getS3Document'
import GetShipmentDocuments from '../../components/getShipmentDocuments'


function CollectionSuccess(props) {
    const [open, setOpen] = React.useState();
    useEffect(() => {setOpen(true); 
        setTimeout(() => {
        setOpen(undefined);
    }, 5000);},[]);
  const shipment = props.location.state.shipment.shipment
  const totalWeight = ReturnTotalWeight(shipment)
  return (
    <Box>
    <NavigationSnackBar title={'Collection Succuessful'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Collection', link: '/collection/new'}, {name: `Shipment ${shipment.id} `}]}  />
    <Box>
      <Box direction='row' justify='between' margin={'small'}><Button secondary hoverIndicator icon={<FormPrevious color={'brand'} onClick={() => {props.history.goBack()}} />} /><Box direction='row' margin='xsmall'><Tag  background='brand' size='small' name="AWB Number" value={shipment.awb_number} /></Box><StatusChip shipment={shipment} /></Box>
    <Box direction='column' justify="center" margin='small' align='center'>
    {open && (<ShipmentSuccessNotification label={"Collection"}/>)}
      <Box margin='small' direction={ReturnRowDir(props.size)} gap='small' justify='center'>
      <ReturnLocation location={shipment.origin} locationType={'Origin'}/>
      <ReturnCollectionDetails shipment={shipment} totalWeight={totalWeight}/>
      <ReturnLocation location={shipment.destination} locationType={'Destination'}/>
      </Box>
      <Box round elevation='medium' margin={{top:'medium'}} background={'background-front'} pad='small'>
      <Box direction='row'><DocumentDownload color='brand' style={{marginTop:10}} /><Text weight={'bold'} margin={'small'}>Shipment Documents</Text></Box>  
      <Box direction="row-responsive" justify='center'>
          <GetShipmentDocuments shipment={shipment} />
          <GetS3Document commodity={shipment.pieces.commodity} />
      </Box>
      </Box>
    </Box>
    </Box>
  </Box>
  )
}

export default withRouter(CollectionSuccess)
